export const styles = {
  icon: {
    height: 24,
    width: 24,
    my: 1,
    mx: 1,
  },
};
